import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import _ from 'lodash'
import { translate } from 'react-i18next'

import { fetchStats } from '../../actions'
import { Roles } from '../../config'
import Loading from '../Loading'

import DashboardSingleBox from './DashboardSingleBox'
import DashboardRemainingBox from './DashboardRemainingBox'
import DashboardPieChart from './DashboardPieChart'

import { Row, Col } from 'antd'

class Dashboard extends Component {
  componentDidMount = () => {
    const { role, match: { params }, user, fetchStats } = this.props

    if (role >= Roles.PROJECT.CLIENT) {
      fetchStats(params.projectId, user.idToken)
    }
  }

  render () {
    const { t, match: { params }, role, contacts, stats, loading, projects } = this.props

    const currentProject = projects[params.projectId]

    let dashboardNumbers = {}
    if (role >= Roles.PROJECT.CLIENT) {
      // get dashboard numbers for clients from redux
      if (!stats || loading.fetchStats) return <Loading />
      dashboardNumbers = stats.status
    } else {
      // calculate dashboard numbers for admins
      const groupedContacts = _.groupBy(contacts, 'status')
      _.map(groupedContacts, (tabContacts, statusCode) => (dashboardNumbers[statusCode] = tabContacts.length))
    }

    // prepare data for summary (status = 0-10)
    let remainingContactsNumbers = {}
    _.forEach([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], status => {
      remainingContactsNumbers[status] = dashboardNumbers[status] || 0
    })

    return (
      <Row gutter={16} style={{ marginBottom: 50, marginTop: 30 }}>

        <Col span={6}>
          <DashboardPieChart
            data={[
              { name: 'recall', value: dashboardNumbers[11] || 0, color: '#3498DB' },
              { name: 'appointments', value: dashboardNumbers[12] || 0, color: '#2ECC71' },
              { name: 'dropOff', value: dashboardNumbers[13] || 0, color: '#E74C3C' }
            ]}
          />
        </Col>

        <Col span={18}>

          <Row type='flex' justify='space-between'>
            <Col span={4}>
              <DashboardSingleBox
                title={t('stats.madeCalls.title')}
                info={t('stats.madeCalls.info')}
                number={currentProject.stats.madeCalls || 0}
              />
            </Col>
            <Col span={4}>
              <DashboardSingleBox
                title={t('stats.notReached.title')}
                info={t('stats.notReached.info')}
                number={dashboardNumbers[14] || 0}
              />
            </Col>
            <Col span={4}>
              <DashboardSingleBox
                title='Reached'
                info='Reached'
                number={dashboardNumbers[12] || 0 + dashboardNumbers[13] || 0}
              />
            </Col>
            <Col span={4}>
              <DashboardSingleBox title='Drop off' info='Drop off' number={dashboardNumbers[13] || 0} />
            </Col>
            <Col span={4}>
              <DashboardSingleBox title='Recall agreed' info='Recall agreed' number={dashboardNumbers[11] || 0} />
            </Col>
          </Row>

          <Row>
            <DashboardRemainingBox numbers={remainingContactsNumbers} />
          </Row>

        </Col>

      </Row>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  user: state.user,
  stats: state.stats,
  loading: state.loading,
  contacts: state.contacts,
  projects: state.projects
})

const mapDispatchToProps = {
  fetchStats
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(translate('translations')(Dashboard)))



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js